import { createApp } from "vue";
import UserNewArticlesPage from "~/components/UserAccounts/UserNewArticlesPage";
import * as dayjs from "dayjs";
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";

document.addEventListener("DOMContentLoaded", () => {
  const app = createApp({
    components: {
      UserNewArticlesPage
    }
  });
  app.config.globalProperties.$dayjs = dayjs;
  app.use(FloatingVue);
  app.mount("#corporation-article");
});
